import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Button} from 'antd';

import UserManual from 'pages/System/UserManual';
import UserManualLabel from 'pages/System/UserManual/UserManualLabel';
import {Modal} from 'ui'

import {UserManualType} from 'pages/System/UserManual/types';


interface UserManualModalInterface {
    open: boolean;
    onCancel: React.Dispatch<React.SetStateAction<boolean>>;
    type: UserManualType;
}

const UserManualModal: React.FC<UserManualModalInterface> = ({open, onCancel, type}) => {
    return (
        <Modal
            open={open}
            maskClosable={false}
            width={'85%'}
            onCancel={() => onCancel(false)}
            title={<UserManualLabel type={type}/>}
            destroyOnClose={true}
            footer={
                <Button onClick={() => onCancel(false)}>
                    <FormattedMessage id='general.close'/>
                </Button>
            }
        >
            <UserManual type={type} />
        </Modal>
    )
};

export default UserManualModal;
